import WorkHourDeadlineForm from './WorkHourDeadlineForm';

export default WorkHourDeadlineForm;
